import p1 from "../../assets/images/p-1.png";
import * as Yup from "yup";
import axios from "axios";
import React, { useState, useEffect } from "react";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from "react-places-autocomplete";
import { GoogleApiWrapper } from "google-maps-react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router";
import { Formik, Form } from "formik";
import { useParams } from "react-router-dom";
import { ReactMultiSelect, TextInput, FileInput, TextArea, NumberInput, } from "../../components/utilityComponent/form-fields";
import { addProduct, updateProduct, fetchProduct, fetchSubCategoryFields } from "../../redux/actions";
import { join } from "@redux-saga/core/effects";
import { toast } from "react-toastify"
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import "./newProductForm.css";

const fullYear = new Date().getFullYear();

const ProductSchema = Yup.object({
    name: Yup.string()
        .trim()
        .min(2, "Minimum of two keywords required")
        .max(50, "Maximum of 50 keywords allowed")
        .required("Listing name is required"),

    buyNowPrice: Yup.number()
        .integer()
        .required("Buy now price is required")
        .moreThan(
            Yup.ref("minimumOfferPrice"),
            "Buy now price should be greater than Minimum offer price"
        ),

    minimumOfferPrice: Yup.number()
        .integer()
        .required("Minimum offer price is required")
        .lessThan(
            Yup.ref("buyNowPrice"),
            "Minimum offer price should be less than Buy Now price"
        ),
    images: Yup.array(
        Yup.string()
            .trim()
            .required("Image object is required")
    )
        .optional()
        .max(10, "Maximum of 10 photos are allowed"),
    description: Yup.string()
        .trim()
        .required("Listing description is required")
        .min(10, "Minimum of 10 keywords required")
        .max(1000, "Maximum of 1000 keywords required"),
    make: Yup.string()
        .trim()
        .optional(),
    model: Yup.string()
        .trim()
        .optional(),
    year: Yup.number().integer().min(1950, "Min year is 1950").max(fullYear, `Max year is ${fullYear}`),

    streetAddress: Yup.string()
        .trim()
        .required("Street Address is Required"),
    address: Yup.string()
        .trim(),

    // state: Yup.string()
    //     .trim(),
    // city: Yup.string()
    //     .trim(),
    postalCode: Yup.string()
        .trim(),

    // country: Yup.string()
    //     .trim(),
    delivery: Yup.string()
        .trim(),
    // .required("Delivery address is required"),
});


const NewProductForm = ({ socket }) => {

    const history = useHistory();
    const { productId } = useParams();
    let product = useSelector((state) => { return state.productDetails.listing; })

    if (productId) {
        product = product.find((p => p._id === productId))
    }
    else {
        product = null;
    }


    const location = useLocation();
    const dispatch = useDispatch();
    // console.log("Location : ", location);
    const [address, setAddress] = useState(product ? product.location : null);
    const [latlng, setLatLng] = useState(product ? product.latlng : null);
    const [country, setCountry] = useState(product ? product.country : null);
    const [state, setState] = useState(product ? product.state : null);
    const [city, setCity] = useState(product ? product.city : null);
    // const [pic, setPic] = useState(product ? product.image : null);

    /** State */
    const user = useSelector((state) => state.userDetails.user)
    const categories = useSelector((state) => state.categoryDetail.categories);
    const subCategories = useSelector((state) => state.subCategoryDetail.subCategories);
    const subCategoryFields = useSelector((state) => state.subCategoryDetail.subCategoryFields);
    const catId = useSelector((state) => state.productDetails.catData.categoryId);
    const subCatId = useSelector((state) => state.productDetails.catData.subCategoryId);
    const [loading, setLoading] = useState();
    const [color, setColor] = useState("#ffffff");
    const [inputFileData, setInputFileData] = useState([]);

    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    // alert('yes')

    const [initialValues, setInitialValues] = useState({
        categoryId: catId,
        subCategoryId: subCatId,
        name: product ? product.title : "",
        images: product ? product.images : [],
        description: product ? product.description : "",
        year: product ? product.year : "",
        location: product ? product.location : "",
        streetAddress: product ? product.streetAddress : "",
        state: product ? product.state : "",
        city: product ? product.city : "",
        postalCode: product ? product.postalCode : "",
        country: product ? product.country : "",
        delivery: product ? product.delivery : "",
        minimumOfferPrice: product ? product.minimumOfferPrice : -1,
        buyNowPrice: product ? product.buyNowPrice : 0,
        frame: product ? product.frame : "", String,
        horns: product ? product.horns : "",
        fertility: product ? product.fertility : "",
        feed: product ? product.feed : "",
        health: product ? product.health : "",
        breed: product ? product.breed : "",
        age: product ? product.age : "",
        scrotalCirc: product ? product.scrotalCirc : "",
        sex: product ? product.sex : "",
        species: product ? product.species : "",
        teeth: product ? product.teeth : "",
        vaccination: product ? product.vaccination : "",
        HGP_treated: product ? product.HGP_treated : false,
        accreditations: product ? product.accreditations : "",
        recommended: product ? product?.recommended : false,
        popular: product ? product?.popular : false,
        bestSelling: product ? product?.bestSelling : false,
        trending: product ? product?.trending : false,
        advertised: product && product.buyNowPrice > 0 ? false : true,
    }),
        [isUploading, setIsUploading] = useState(false),
        [progress, setProgress] = useState(0);

    useEffect(() => {
        setInputFileData([...inputFileData, ...initialValues.images]);
    }, [])

    useEffect(() => {
        console.log("input file data display: ", inputFileData);
    }, [inputFileData])


    //console.log("Sub Category Fields", subCategoryFields);
    // console.log("initial values are: ", initialValues);

    const categoryOptions = categories.map((category) => {
        return {
            key: category._id,
            label: category.name,
            value: category._id,
        };
    });
    // alert(JSON.stringify(categoryOptions))
    const subCategoryOptions = subCategories.map((category) => {
        return {
            key: category._id,
            label: category.name,
            value: category._id,
            parentCategoryId: category.parentCategoryId,
        };
    });

    const year = new Date().getFullYear();
    const years = Array.from(new Array(10), (val, index) => year - index);
    const yearOptions = years.map((year) => {
        return { label: year, value: year, };
    });

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        if (name === "address") {
            setInitialValues({ ...initialValues, [name]: address });
        }
        else if (name === "recommended" || name === "popular" || name === "bestSelling" || name === "trending") {
            setInitialValues({ ...initialValues, [name]: value === "true" ? true : false });
        }
        else {
            setInitialValues({ ...initialValues, [name]: value });
        }
    };

    const handlePhotoChange = async (event) => {
        event.preventDefault();
        const files = event.target.files;
        console.log("image files: ", files);
        const totalLength = files.length + inputFileData.length;
        if (totalLength > 10) {
            toast.error("Can't select more than 10 images");
            event.target.value = null;
        }
        else if (checkMimeType(event)) {
            setInputFileData([...inputFileData, ...files]);
            // console.log("images response: ", response.data);

            // alert(response.data)
            // setInitialValues({ ...initialValues, images: response.data });
            // setPic(file[0]);
            // document
            //   .getElementById("bannerImage")
            //   .setAttribute("src", URL.createObjectURL(file[0]));
        }
        else {
            toast.error("An unexpected file type was selected");
            event.target.value = null;
        }
    };

    const checkMimeType = (event) => {
        //getting file object
        let files = event.target.files;
        // list allow mime type
        const types = ["image/png", "image/jpeg", "image/gif"];

        // compare file type find doesn't matach
        for (let i = 0; i < files.length; i++) {
            //define message container
            let err = "";
            if (types.every((type) => files[i].type !== type)) {
                // create error message and assign to container
                err = files[i].type + " is not a supported format";
            }
            if (err !== "") {
                // if message not same old that mean has error
                event.target.value = null; // discard selected file
                console.log(err);
                return false;
            }
        }
        return true;
    };

    const handleSelect = async (value) => {
        const results = await geocodeByAddress(value);
        const result = results[0];
        const addressComponents = result.address_components;
        for (let i = 0; i < addressComponents.length; i++) {
            let component = addressComponents[i];
            if (component.types.indexOf('country') !== -1) {
                setCountry(component.long_name);
            }
            else if (component.types.indexOf('administrative_area_level_1') !== -1) {
                setState(component.long_name);
            }
            else if (component.types.indexOf('locality') !== -1) {
                setCity(component.long_name);
            }
        }
        const coordinates = await getLatLng(result);
        setAddress(value);
        setLatLng([coordinates.lng, coordinates.lat]);
    }

    const onSubmit = (values) => {
        setIsUploading(true)
        setLoading(true);
        console.log("Submitted values: ", values);
        // constonSubmit formData = new FormData();
        let data = {
            ...values,
            // subCategoryName: location.state?.subCategoryName,
            // categoryName: location.state?.categoryName,
            // status: "Active",
            latlng: latlng,
            location: address,
            country,
            city,
            state
        };
        data.inputFileData = inputFileData;
        console.log("submitted data values: ", data);
        if (productId) {

            const callback = async () => {

                setIsUploading(false);
                setLoading(false);


            };
            // dispatch(updateProduct({ id: productId, data, callback }));
            data.id = productId;
            dispatch(updateProduct({ data, callback, history }));
        }
        else {

            data = { ...data };
            data.shareCode = Math.random()
                .toString(36)
                .substr(2, 6)
                .toUpperCase();
            const callback = async (response) => {
                setIsUploading(false);
                setLoading(false);
                if (response.data.success) {
                    socket.emit("new_notification",
                        {
                            name: user.firstname,
                            email: user.email,
                            message: `added new Listing`
                        });
                    const url = process.env.REACT_APP_SERVER_URL;
                    const endpoint = `${url}/v1/notifications/add-notifications`
                    const data = { name: user.firstname, email: user.email, message: `added new Listing` }
                    await axios({ data, headers: { 'Content-Type': 'application/json', 'Authorization': Cookies.get('token') }, method: 'post', timeout: 1000 * 60 * 10, url: endpoint, });

                }
            };

            dispatch(addProduct({ values: data, callback, history }));
        }
    };

    //   useEffect(() => {
    //     if (id) {
    //       dispatch( fetchProduct({ id, callback: (data) => {  console.log("Data", data);
    //             setInitialValues({
    //               productId: data.id,
    //               name: data.name,
    //               images: data.images,
    //               description: data.description ? data.description : "",
    //               make: data.make ? data.make : "",
    //               model: data.model ? data.model : "",
    //               year: data.year ? data.year : "",
    //               streetAddress: data.streetAddress ? data.streetAddress : "",
    //               address: data.address ? data.address : "",
    //               state: data.state ? data.state : "",
    //               city: data.city ? data.city : "",
    //               postalCode: data.postalCode ? data.postalCode : "",
    //               country: data.country ? data.country : "",
    //               delivery: data.delivery ? data.delivery : "",
    //               minimumOfferPrice: data.minimumOfferPrice
    //                 ? data.minimumOfferPrice
    //                 : "",
    //               buyNowPrice: data.buyNowPrice ? data.buyNowPrice : "",
    //               condition: data.condition ? data.condition : "",
    //               serialnumber: data.serialnumber ? data.serialnumber : "",
    //               enginehours: data.enginehours ? data.enginehours : "",
    //               header: data.header ? data.header : "",
    //               stocknumber: data.stocknumber ? data.stocknumber : "",
    //               combinetype: data.combinetype ? data.combinetype : "",
    //             });
    //             setAddress(data.address);
    //             if (data.latlng) {        setLatLng(data.latlng);       }
    //           },
    //         })
    //       );
    //     }
    //   }, [dispatch, id]);

    //   useEffect(() => {
    //     dispatch(   ({  id: location.state?.subCategoryId,  callback: (data) => {}, }) );
    //   }, [dispatch, location.state?.subCategoryId]);

    const onCategoryChange = (e) => {
        setInitialValues({ ...initialValues, categoryId: e.value });
    };

    const onSubCategoryChange = (e) => {
        setInitialValues({ ...initialValues, subCategoryId: e.value });
    };

    const onYearChange = (e) => {
        setInitialValues({ ...initialValues, year: e.value });
    };

    const removeImage = async (image) => {
        // console.log("values of input file: ", document.getElementById("multiFileInput").values);
        console.log("removable image: ", image);
        const files = inputFileData.filter(i => i !== image);
        const images = files.filter(i => typeof (i) !== "object");
        setInitialValues({ ...initialValues, images });
        setInputFileData(files);
        // console.log("image: ", image);
        // console.log("inputFileData to be removed: ", inputFileData);

        // setInputFileData();
        // const images = initialValues.images.filter(i => i !== image);
        // setInitialValues({ ...initialValues, images: images });
        // axios.post(`${process.env.REACT_APP_SERVER_URL}/v1/remove-image`, { image }, { headers: { 'Authorization': Cookies.get('token') }, }).then(
        //     res => console.log(res.data)
        // ).catch(err => console.log(err))
    }

    const handleToggle = (e) => {
        if (e.target.checked) {
            setInitialValues({ ...initialValues, advertised: false });
        }
        else {
            setInitialValues({ ...initialValues, advertised: true, buyNowPrice: 0, minimumOfferPrice: -1 });
        }

    }


    return (

        <>
            <div className="dashContentHeader px-5 mb-3 row">
                {productId && <h5 className="dashHeading mb-0 fontfammedium p-0">Edit Product</h5>}
                {!productId && <h5 className="dashHeading mb-0 fontfammedium p-0">Add New Product </h5>}

            </div>
            <div className="row dashboardCardRow px-5">
                <div className="col-lg-8 bg-white mt-5 shadow">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={ProductSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ errors, values }) => (
                            console.log("Errors : ", errors),
                            (
                                <Form className="mg-login new-product mt-4 px-3">
                                    <div className="row mb-0">
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Listing Title"
                                                name="name"
                                                id="name"
                                                type="text"
                                                placeholder="Title"
                                                className="form-control "
                                                onChange={handleOnChange}
                                                isRequired
                                                errors={errors}
                                            />
                                        </div>
                                        <h5 className="dashHeading mb-0 mx-3 fontfammedium">
                                            Upload Photo
                                        </h5>
                                        <p className="text-lt textp-lt  mt-2 mb-3 w-100 mx-3 font-16">
                                            You can upload up max 10 photos.{" "}
                                        </p>
                                        <div className="col-md-12 mb-4 form-group d-flex flex-wrap">
                                            <div className="col-md-4 upload-product mb-3">
                                                <label htmlFor="multiFileInput" className="w-auto">
                                                    <svg
                                                        width="64"
                                                        height="54"
                                                        viewBox="0 0 64 54"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M28.8207 21.6809C25.6147 21.6809 23.0156 24.2799 23.0156 27.4859C23.0156 30.6919 25.6146 33.291 28.8207 33.291C32.0266 33.291 34.6257 30.692 34.6257 27.4859C34.6257 24.2799 32.0267 21.6809 28.8207 21.6809ZM28.8207 30.5265C27.1413 30.5265 25.7799 29.1652 25.7799 27.4858C25.7799 25.8064 27.1413 24.4451 28.8207 24.4451C30.5 24.4451 31.8614 25.8064 31.8614 27.4858C31.8614 29.1652 30.5 30.5265 28.8207 30.5265Z"
                                                            fill="#FF7E06"
                                                        />
                                                        <path
                                                            d="M51.9704 8.41232L14.238 4.1278C12.7736 3.91959 11.2898 4.34711 10.1607 5.30266C9.03176 6.17806 8.30808 7.47568 8.15663 8.89618L7.46562 14.563H5.32316C2.28242 14.563 0.00186758 17.2581 0.00186758 20.2988V48.5635C-0.0747197 51.4631 2.21377 53.8759 5.11351 53.9525C5.18335 53.9543 5.25332 53.9543 5.32316 53.9543H43.2628C46.3036 53.9543 49.0679 51.6043 49.0679 48.5635V47.4578C50.0106 47.2757 50.9049 46.8991 51.6939 46.3521C52.8136 45.4094 53.5306 44.0744 53.698 42.6204L56.877 14.563C57.2011 11.5152 55.0139 8.77356 51.9704 8.41232ZM46.3037 48.5635C46.3037 50.0839 44.7832 51.1896 43.2628 51.1896H5.32316C3.94975 51.2299 2.80372 50.1492 2.76338 48.7758C2.76126 48.705 2.76227 48.6343 2.76615 48.5635V43.4496L13.4778 35.5714C14.7646 34.5835 16.577 34.6713 17.7624 35.7787L25.2951 42.413C26.439 43.3734 27.879 43.9103 29.3725 43.9334C30.5402 43.9476 31.6888 43.6367 32.6897 43.0349L46.3037 35.1568V48.5635ZM46.3036 31.9087L31.2382 40.6853C29.9446 41.4517 28.3072 41.313 27.1609 40.3398L19.5591 33.6364C17.3804 31.7643 14.196 31.6495 11.8882 33.3599L2.76615 39.9942V20.2988C2.76615 18.7785 3.80279 17.3273 5.32316 17.3273H43.2628C44.8872 17.3946 46.199 18.6766 46.3036 20.2988V31.9087ZM54.1154 14.1898C54.1144 14.199 54.1136 14.2082 54.1126 14.2173L50.8646 42.2748C50.8701 43.0023 50.5384 43.6913 49.9662 44.1406C49.6897 44.4171 49.0677 44.5553 49.0677 44.6935V20.2988C48.9586 17.1505 46.4121 14.6343 43.2627 14.563H10.2298L10.8517 9.17264C10.9867 8.47462 11.3516 7.84208 11.8884 7.37581C12.4945 6.95676 13.2273 6.76139 13.9617 6.8229L51.625 11.1766C53.1446 11.3209 54.2597 12.67 54.1154 14.1898Z"
                                                            fill="#FF7E06"
                                                        />
                                                        <path
                                                            d="M50.5 27C57.9558 27 64 20.9558 64 13.5C64 6.04416 57.9558 0 50.5 0C43.0442 0 37 6.04416 37 13.5C37 20.9558 43.0442 27 50.5 27Z"
                                                            fill="#FF7E06"
                                                        />
                                                        <path
                                                            d="M51.0391 8.08545V17.9946"
                                                            stroke="white"
                                                            strokeWidth="1.6"
                                                            strokeLinecap="round"
                                                        />
                                                        <path
                                                            d="M55.9961 13.04H46.0869"
                                                            stroke="white"
                                                            strokeWidth="1.6"
                                                            strokeLinecap="round"
                                                        />
                                                    </svg>
                                                </label>
                                                <input type='file' multiple='multiple' accept='image/*' name='uploadedImages' id='multiFileInput' onChange={handlePhotoChange} />
                                            </div>

                                            {inputFileData && inputFileData.map((image, index) => (
                                                <div
                                                    className="col-md-4 mb-3 group-image-frame"
                                                    key={index}
                                                >
                                                    <img src={typeof (image) === "object" ? URL.createObjectURL(image) : `${process.env.REACT_APP_SERVER_URL}/images/${image}`} alt="Missing File" className="product-image" />
                                                    <div className="delete-img">
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            onClick={() => removeImage(image)}
                                                        >
                                                            <circle
                                                                cx="12"
                                                                cy="12"
                                                                r="11"
                                                                fill="#FF7E06"
                                                                stroke="white"
                                                                stroke-width="2"
                                                            />
                                                            <path
                                                                d="M15 9L9 15"
                                                                stroke="white"
                                                                stroke-width="1.5"
                                                                stroke-linecap="round"
                                                            />
                                                            <path
                                                                d="M9 9L15 15"
                                                                stroke="white"
                                                                stroke-width="1.5"
                                                                stroke-linecap="round"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ))}

                                            {/* {inputFileData &&
                                                inputFileData.map((file, index) => (
                                                    // <div>
                                                    //     {"hello" + inputFileData[key].name}
                                                    // </div>
                                                    <div
                                                        className="col-md-4 upload-image mb-3"
                                                        key={index}
                                                    >
                                                        <img src={URL.createObjectURL(file)} alt="Missing File" />
                                                        <div className="delete-img">
                                                            <svg
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                onClick={() => removeImage(file)}
                                                            >
                                                                <circle
                                                                    cx="12"
                                                                    cy="12"
                                                                    r="11"
                                                                    fill="#FF7E06"
                                                                    stroke="white"
                                                                    stroke-width="2"
                                                                />
                                                                <path
                                                                    d="M15 9L9 15"
                                                                    stroke="white"
                                                                    stroke-width="1.5"
                                                                    stroke-linecap="round"
                                                                />
                                                                <path
                                                                    d="M9 9L15 15"
                                                                    stroke="white"
                                                                    stroke-width="1.5"
                                                                    stroke-linecap="round"
                                                                />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                ))} */}
                                            {/* <ProgressBar
                          isUploading={isUploading}
                          percentUploaded={progress}
                        /> */}
                                        </div>
                                        <div className="col-12">
                                            <hr className="w-100 mb-4" />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextArea
                                                label="Description"
                                                className="form-control"
                                                name="description"
                                                placeholder="Type here"
                                                id="description"
                                                onChange={handleOnChange}
                                                errors={errors}
                                                isRequired
                                            />
                                        </div>

                                        <div className="col-md-12 mb-4 form-group">
                                            <ReactMultiSelect
                                                label="CHOOSE A CATEGORY"
                                                options={categoryOptions}
                                                handleChange={onCategoryChange}
                                                disabled={true}
                                                name="categoryId"
                                                id="categoryId"
                                                value={categoryOptions.find((option) => {
                                                    // console.log("option.value: " + option.value + " , initialValues.categoryId: ", initialValues.categoryId);
                                                    return option.value === initialValues.categoryId;
                                                })}
                                                placeholder="CATEGORY"
                                                className="form-control form-select"
                                                errors={errors}
                                                isRequired
                                            />
                                        </div>


                                        <div className="col-md-12 mb-4 form-group">
                                            <ReactMultiSelect
                                                label="CHOOSE A SUB CATEGORY"
                                                options={subCategoryOptions.filter((data) => {
                                                    return (
                                                        data.parentCategoryId === initialValues.categoryId
                                                    );
                                                })}
                                                handleChange={onSubCategoryChange}
                                                name="subCategoryId"
                                                disabled={true}
                                                id="subCategoryId"
                                                value={subCategoryOptions.find((option) => {
                                                    return option.value === initialValues.subCategoryId;
                                                })}
                                                placeholder="SUB CATEGORY"
                                                className="form-control form-select"
                                                errors={errors}
                                                isRequired
                                            />
                                        </div>


                                        <div className="col-md-12 mb-4 form-group">
                                            {/* <ReactMultiSelect
                                                label="Year"
                                                options={yearOptions}
                                                handleChange={onYearChange}
                                                name="year"
                                                id="year"
                                                value={yearOptions.find((option) => {
                                                    return option.value === values.year;
                                                })}
                                                placeholder="Year"
                                                className="form-control form-select"
                                                errors={errors}

                                            /> */}
                                            <NumberInput
                                                label="Year"
                                                onWheel={() => document.activeElement.blur()}
                                                className="form-control"
                                                id="year"
                                                name="year"
                                                placeholder="Enter Year"
                                                errors={errors}
                                                onChange={handleOnChange}
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <label className="right-label-checkbox" for="isAdvertised">if Listing not advertised product then select to add listing price
                                                <input id="isAdvertised" type="checkbox" className="custom-control-input" onChange={handleToggle} checked={initialValues?.advertised === true ? false : true} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <NumberInput
                                                label="Buy Now Price"
                                                onWheel={() => document.activeElement.blur()}
                                                className="form-control"
                                                id="buyNowPrice"
                                                name="buyNowPrice"
                                                placeholder="Enter here.."
                                                errors={errors}
                                                isRequired
                                                min="0"
                                                onChange={handleOnChange}
                                                disabled={initialValues?.advertised}
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <NumberInput
                                                label="Minimum Offer Price"
                                                onWheel={() => document.activeElement.blur()}
                                                className="form-control"
                                                id="minimumOfferPrice"
                                                name="minimumOfferPrice"
                                                placeholder="Enter here.."
                                                errors={errors}
                                                isRequired
                                                min="-1"
                                                onChange={handleOnChange}
                                                disabled={initialValues?.advertised}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <hr className="w-100 mb-4" />
                                        </div>


                                        <h5 className="dashHeading mb-4 mt-3 mx-3 fontfammedium">
                                            General Features
                                        </h5>

                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Age"
                                                className="form-control"
                                                id="age"
                                                name="age"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>


                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Breed"
                                                className="form-control"
                                                id="breed"
                                                name="breed"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>


                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Health"
                                                className="form-control"
                                                id="health"
                                                name="health"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>


                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Feed"
                                                className="form-control"
                                                id="feed"
                                                name="feed"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>


                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Fertility"
                                                className="form-control"
                                                id="fertility"
                                                name="fertility"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>



                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Horns"
                                                className="form-control"
                                                id="horns"
                                                name="horns"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>

                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Frame"
                                                className="form-control"
                                                id="frame"
                                                name="frame"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <hr className="w-100 mb-4" />
                                        </div>

                                        <h5 className="dashHeading mb-4 mt-3 mx-3 fontfammedium">
                                            Add Location
                                        </h5>
                                        {/* <div className="col-md-12 mb-4 form-group">
                        <PlacesAutocomplete
                          value={address}
                          onChange={(e) => {
                            setAddress(e);
                          }}
                          onSelect={(e) => {
                            setAddress(e);
                            // handleSelect(e);
                          }}
                        >
                          {({
                            getInputProps,
                            suggestions,
                            getSuggestionItemProps,
                            loading,
                          }) => (
                            <div>
                              <TextInput
                                label="Address"
                                className="form-control"
                                id="address"
                                name="address"
                                placeholder="Enter here.."
                                onChange={handleOnChange}
                                {...getInputProps({
                                  placeholder: "Search Places ...",
                                  className:
                                    "location-search-input form-control",
                                })}
                                isRequired
                                required
                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map((suggestion) => {
                                  const className = suggestion.active
                                    ? "suggestion-item--active"
                                    : "suggestion-item";
                                  const style = suggestion.active
                                    ? {
                                        backgroundColor: "#fafafa",
                                        cursor: "pointer",
                                      }
                                    : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                      };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <span>{suggestion.description}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>
                      </div> */}
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Street Address"
                                                className="form-control"
                                                id="streetAddress"
                                                name="streetAddress"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                                isRequired
                                            />
                                        </div>

                                        <div className="col-md-12 mb-4 form-group">
                                            {/* <TextInput
                        label="Location"
                        className="form-control"
                        id="address"
                        name="address"
                        placeholder="Enter here.."
                        onChange={handleOnChange}
                      /> */}
                                            <PlacesAutocomplete value={address} onChange={setAddress} onSelect={handleSelect}>
                                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                    <div>
                                                        {/* <label for="addressAutoComplete">Location</label>
                                                        <input {...getInputProps({ placeholder: "Enter Location" })} id="address" name="address" className="form-control" /> */}
                                                        <TextInput label="Location" className="form-control" id="address" name="address" placeholder="Enter here.." onChange={handleOnChange}
                                                            {...getInputProps({ placeholder: "Search Places ...", className: "location-search-input form-control", })} isRequired required />

                                                        <div style={{ position: "relative" }}>
                                                            <div style={{
                                                                position: "absolute",
                                                                zIndex: 1,
                                                            }}>
                                                                {loading ? <div>...Loading</div> : null}
                                                                {suggestions.map((suggestion) => {
                                                                    const style = {
                                                                        backgroundColor: suggestion.active ? "#ff7e06" : "#fff",
                                                                    };
                                                                    return <div {...getSuggestionItemProps(suggestion, { style })}>{suggestion.description}</div>;
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </PlacesAutocomplete>
                                        </div>

                                        <div className="col-md-12 mb-4 form-group">

                                            <TextInput
                                                label="State"
                                                className="form-control"
                                                id="state"
                                                name="state"
                                                value={state}
                                                placeholder="Enter Location.."
                                                disabled={true}
                                                isRequired
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">

                                            <TextInput
                                                label="City"
                                                className="form-control"
                                                id="city"
                                                name="city"
                                                value={city}
                                                placeholder="Enter Location.."
                                                disabled={true}
                                                isRequired
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">

                                            <TextInput
                                                label="Country"
                                                className="form-control"
                                                id="country"
                                                name="country"
                                                value={country}
                                                placeholder="Enter Location.."
                                                disabled={true}
                                                isRequired
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Postal Code"
                                                className="form-control"
                                                id="postalCode"
                                                name="postalCode"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">

                                            <TextInput
                                                label="Delivery"
                                                className="form-control"
                                                id="delivery"
                                                name="delivery"
                                                placeholder="Enter here.."
                                                onChange={handleOnChange}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <hr className="w-100 mb-4" />
                                        </div>


                                        {/* {subCategoryFields.map((field, key) => {
                                            return (
                                                <React.Fragment key={key}>
                                                    <div className="col-md-12 mb-4 form-group">
                                                        {field.fieldType === "media" && (
                                                            <FileInput
                                                                label={`${field.title}`}
                                                                className="col-md-4 upload-product"
                                                                name="myFile"
                                                                //   onChange={handleFireBaseUpload}
                                                                errors={errors}
                                                            ></FileInput>
                                                        )}
                                                        {field.fieldType === "string" && (
                                                            <TextInput
                                                                label={`${field.title}`}
                                                                className="form-control"
                                                                id="delivery"
                                                                name={`${field.title}`}
                                                                placeholder="Enter here.."
                                                                onChange={handleOnChange}
                                                            />
                                                        )}
                                                        {field.fieldType === "number" && (
                                                            <TextInput
                                                                label={`${field.title}`}
                                                                className="form-control"
                                                                id="delivery"
                                                                name={`${field.title}`}
                                                                placeholder="Enter here.."
                                                                onChange={handleOnChange}
                                                            />
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })} */}
                                        {user.role[0] === "admin" && <>
                                            <h5 className="dashHeading mb-4 mt-3 mx-3 fontfammedium">
                                                Filters
                                            </h5>
                                            <div className="row col-12 mb-0">
                                                <div className="col-md-3 mb-4 form-group mg-login">
                                                    <label >Recommended</label>
                                                    <div className="d-flex flex-wrap">
                                                        <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                className="mr-1"
                                                                type="radio"
                                                                name="recommended"
                                                                value={true}
                                                                onClick={handleOnChange}
                                                                checked={initialValues.recommended ? true : false}
                                                            />
                                                            <label > Yes</label>
                                                        </div>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                className="mr-1"
                                                                type="radio"
                                                                name="recommended"
                                                                value={false}
                                                                onClick={handleOnChange}
                                                                checked={!initialValues.recommended ? true : false}
                                                            />
                                                            <label> No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mb-4 form-group mg-login">
                                                    <label >Popular</label>
                                                    <div className="d-flex flex-wrap">
                                                        <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                className="mr-1"
                                                                type="radio"
                                                                name="popular"
                                                                value={true}
                                                                onClick={handleOnChange}
                                                                checked={initialValues.popular ? true : false}
                                                            />
                                                            <label > Yes</label>
                                                        </div>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                className="mr-1"
                                                                type="radio"
                                                                name="popular"
                                                                value={false}
                                                                onClick={handleOnChange}
                                                                checked={!initialValues.popular ? true : false}
                                                            />
                                                            <label> No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mb-4 form-group mg-login">
                                                    <label >Best Selling</label>
                                                    <div className="d-flex flex-wrap">
                                                        <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                className="mr-1"
                                                                type="radio"
                                                                name="bestSelling"
                                                                value={true}
                                                                onClick={handleOnChange}
                                                                checked={initialValues.bestSelling ? true : false}
                                                            />
                                                            <label > Yes</label>
                                                        </div>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                className="mr-1"
                                                                type="radio"
                                                                name="bestSelling"
                                                                value={false}
                                                                onClick={handleOnChange}
                                                                checked={!initialValues.bestSelling ? true : false}
                                                            />
                                                            <label> No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mb-4 form-group mg-login">
                                                    <label >Trending</label>
                                                    <div className="d-flex flex-wrap">
                                                        <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                className="mr-1"
                                                                type="radio"
                                                                name="trending"
                                                                value={true}
                                                                onClick={handleOnChange}
                                                                checked={initialValues.trending ? true : false}
                                                            />
                                                            <label > Yes</label>
                                                        </div>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                className="mr-1"
                                                                type="radio"
                                                                name="trending"
                                                                value={false}
                                                                onClick={handleOnChange}
                                                                checked={!initialValues.trending ? true : false}
                                                            />
                                                            <label> No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <hr className="w-100 mb-4" />
                                            </div>
                                        </>}
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between mb-5">
                                        <button className="mb-5 sub-button mt-4 px-4" onClick={() => {
                                            if (productId)
                                                history.push(`/edit-post-new-listing/${product._id}`)
                                            else
                                                history.push('/post-new-listing');

                                        }}>Back</button>
                                        <button
                                            type="submit"
                                            disabled={isUploading}
                                            className="mb-5 sub-button mt-4 px-4"
                                        >
                                            {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                                            {!loading && (productId ? "Update" : "Submit")}
                                        </button>
                                    </div>
                                </Form>
                            )
                        )}
                    </Formik>
                    <form className="mg-login new-product mt-4 px-3"></form>
                </div>
            </div>
        </>
    );
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyBApvvMp-DolYwwyo3C2jpq6lGDpZzLeiU",
    libraries: ["places"],
})(NewProductForm);